<ul class="module-items {{modulesClass}} {{group.key}}-active {{#if all_complete}}all-completed{{/if}}" data-active-group="{{group.key}}"></ul>
